import React from 'react';
import ContractList from './ContractList';
import { contractsColumns } from '../enums/columns';
import useAppContext from '../../../hooks/context/useAppContext';
import userRoles from '../../../constants/userRoles';

const columns = [
  contractsColumns.state,
  contractsColumns.idExternal,
  contractsColumns.frameContract,
  contractsColumns.organisation,
  contractsColumns.sapId,
  contractsColumns.kam,
  contractsColumns.commodity,
  contractsColumns.contractPeriod,
  contractsColumns.currency,
  contractsColumns.invoicingCurrency,
  contractsColumns.deliveryProduct,
  contractsColumns.productType,
  contractsColumns.volume,
  contractsColumns.pnMethod,
  contractsColumns.purchaseMethod,
  contractsColumns.priceType,
  contractsColumns.reversePurchase,
  contractsColumns.purchasedPercent,
  contractsColumns.remains,
  contractsColumns.remains1,
  contractsColumns.remains2,
  contractsColumns.remains3,
  contractsColumns.remains4,
  contractsColumns.remains5,
  contractsColumns.remains6,
  contractsColumns.remains7,
  contractsColumns.remains8,
  contractsColumns.remains9,
  contractsColumns.remains10,
  contractsColumns.remains11,
  contractsColumns.remains12,
];

const ContractListOthers = () => {
  const { user } = useAppContext();
  return <ContractList columns={columns} showToolbarIcons={user.role === userRoles.ADMIN} />;
};

export default ContractListOthers;
